/**
 * 判断 URL 是否为可信任的地址。
 *
 * 如果是可信任，则可以在 hashframe 中打开，并自动个传递通用参数
 * 如果是不可信任 URL，则有各个业务自行判断是直接忽略还是使用 window.open 打开
 */
const isSafeUrl = (url: string): boolean => {
    const tempLink = document.createElement('a');
    tempLink.href = url;
    const targetHost = tempLink.host;
    const targetHrefLowerCase = url.toLowerCase();
    if (
        (targetHrefLowerCase.indexOf('http') === -1 ||
            targetHost.match(/\.meituan\.com$/) ||
            targetHost.match(/\.sankuai\.com$/) ||
            targetHost.match(/\.dianping\.com$/) ||
            targetHost.match(/\.dpurl\.com$/) ||
            targetHost.match(/\.dpurl\.cn$/) ||
            targetHost === 'meituan.com' ||
            targetHost === 'sankuai.com' ||
            targetHost === 'dianping.com' ||
            targetHost === 'dpurl.cn' ||
            targetHost === 'dpurl.com') &&
        // eslint-disable-next-line no-script-url
        targetHrefLowerCase.indexOf('javascript:') === -1 &&
        url.indexOf('\\') === -1
    ) {
        return true;
    } else {
        return false;
    }
};

export default isSafeUrl;
